

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, rest), ["\n  ", h('g', {"fill":"none","fill-rule":"evenodd"}, ["\n    ", h('circle', {"cx":"12","cy":"12","r":"12","fill":"currentColor"}, []), "\n    ", h('path', {"fill":"#EBEBEB","fill-rule":"nonzero","d":"M14.552 14.321a.675.675 0 0 0 1.025-.872l-.071-.084-3.177-3.168a.675.675 0 0 0-.87-.07l-.084.07-3.177 3.168a.675.675 0 0 0 .87 1.027l.084-.071 2.7-2.693 2.7 2.693Z"}, []), "\n  "]), "\n"]);
};

        